<a
  [href]="href()"
  [class]="'s__link s__link--' + variant() + (color() === 'alt' ? ' s__link--alt' : '')"
>
  <ng-content />
  @if (variant() === 'arrow') {
    <span class="s__link__arrow" aria-hidden="true">&rarr;</span>
  }
</a>
